import React from "react";
import {connect} from "react-redux";
import {Row, Modal, Button} from "react-bootstrap";
import {loginWithEmail, forgetPassword, logOut,
    loginWithFacebook, setShowCreateFBAccount,
    setForgetPassword, changePassword, setChangePassword,
    resetStatus, setResetPasswordEmailSent, activateFacebook,
    resetEmailSent, setEnableFbButton,showFBErrorMessage} from "../../actions/login/logInActions";
import {translate} from "../../i18n/translate.js";
import {initFacebook, isEmptyObj} from "../../common/utils";
import LoginLinkFBAccount from "../../components/login/LoginLinkFBAccount.js";
import LoginForgetPassword from "../../components/login/LoginForgetPassword.js";
import LoginChangePassword from "../../components/login/LoginChangePassword.js";
import {URLs, FetchingTypes} from "../../common/constants";
import {initServerStaticData} from "../../actions/common/staticDataActions";
import LoginInputField from "../../components/login/LoginInputField";
import {isFetching} from "../../actions/common/fetchingActions";
import {fetchingData, dataFetched} from "../../actions/common/fetchingActions";
import styles from "../../css/login/login.less";

class LogInScreen extends React.Component {
    constructor(props) {
        super(props);
        if (isEmptyObj(props.staticData)) {
            initServerStaticData();
        }

        this.state = {
            email: '',
            password: '',
            facebookId: ''
        };
    }

    componentWillMount() {
        initFacebook(this.props.facebookAppId, false, this.enableFBButton);
    }

    enableFBButton = () => {
        if(!this.unmounted) {
            this.props.setEnableFbButton(true);
        }
    };

    componentWillUnmount() {
        this.unmounted = true;
    }

    statusChangeCallback = (response, logOut, shouldNotLogin) => {
        console.log(response);
        if (response.status === 'connected') {
            if(logOut && this.props.memberDetails.key)
                FB.logout(function(response) {
                    console.log("Facebook log out");
                });
            else if (response.authResponse) {
                FB.api('/me',{fields:'id,first_name,last_name,email'}, function(response) {
                    this.setState({facebookId: response.id, email: response.email});
                    this.props.loginWithFacebook(response.email, response.id, true, "");
                }.bind(this));
            } else {
                console.log('User cancelled login or did not fully authorize.');
            }
        } else if (!shouldNotLogin) {
            FB.login(function(response) {
                this.statusChangeCallback(response, false, true) ;
            }.bind(this));
        }
    };

    checkLoginState = () => {
        if (!this.isFBLoaded())
            return;
        FB.getLoginStatus(function(response) {
            this.statusChangeCallback(response);
        }.bind(this));
    };

    isFBLoaded = () => {
        if (typeof(FB) === 'undefined'){
            initFacebook(this.props.facebookAppId, true, this.enableFBButton);
            this.props.showFBErrorMessage();
            return false;
        }
        return true;
    };

    handleChangeEmail = (value) => {
        this.setState({email: value});
    };

    handleChangePassword = (value) => {
        this.setState({password: value});
    };

    emailLoginClicked = () => {
        this.props.loginWithEmail(this.state.email, this.state.password);
    };

    forgetPasswordClicked = () => {
        this.props.resetStatus();
        this.props.setForgetPassword(true);
    };

    closeCreateFBAccount = () => {
        this.props.setShowCreateFBAccount(false);
    };

    getCreateFBLogInPopup = () => {
        return (
            <Modal show={this.props.loginStatus.showCreateFBAccount} onHide={this.closeCreateFBAccount} >
                <Modal.Header><button className="close" onClick={this.closeCreateFBAccount}><span>x</span></button></Modal.Header>
                <Modal.Body>
                    <LoginLinkFBAccount email={this.props.loginStatus.email} facebookId={this.state.facebookId}
                                        component={this.props.loginStatus.component}
                                        status={this.props.loginStatus.status}
                                        createFBAccount={this.props.createFBAccount}
                                        showLoading={this.props.showLoading}/>
                </Modal.Body>
            </Modal>
        )
    };

    getLoginPage = () => {
        let className = "border-container";
        if(URLs.JOIN == this.props.flowType) {
            className += " border-container-join";
        }
        return <div className={className}>
                    <div className="inner-container login-container">
                        <form>
                        <fieldset className="form-container container-fluid" disabled={this.props.showLoading}>
                            <Row className="sign-in-fb">
                                <Button className={"button fb-login-button" + (this.props.showLoading ? " loading" : "")} onClick={this.checkLoginState}
                                        disabled={!this.props.fbButtonEnabled}>
                                    <div className="fb-img"/><div className="btn-fb-text">{translate('Login with Facebook')}</div>
                                </Button>
                            </Row>
                            <Row>
                                <div className="or-sign-in">{translate('or')}</div>
                            </Row>
                            <Row className="email-form-title">
                                <div className="email-img"/>
                                {translate('Login with Email')}
                            </Row>
                            <LoginInputField id="email" type="email" value={this.state.email} label={translate("email")} placeholder={translate("Email")}
                                             error={!this.props.loginStatus.showCreateFBAccount && this.props.loginStatus.component==="email"?
                                                 this.props.loginStatus.status:undefined} update={this.handleChangeEmail} validate={this.validateEmail} ref="email"/>
                            <LoginInputField id="password" type="password" value={this.state.password} label={translate("password")} placeholder={translate("Password")}
                                             error={!this.props.loginStatus.showCreateFBAccount && this.props.loginStatus.component === "password"?
                                                 this.props.loginStatus.status:undefined} update={this.handleChangePassword} ref="password"/>
                            <Row className="email-log-in">
                                <Button bsStyle="primary" className={"button email-login-button" + (this.props.showLoading ? " loading" : "")} id="btnlogin" onClick={this.emailLoginClicked}>
                                    <div className="btn-email-text">{translate('Login')}</div>
                                </Button>
                            </Row>
                            <Row className="forget-password-row">
                                <a className="forget-password"
                                    onClick={this.forgetPasswordClicked}>{translate('Forgot Password')}</a>
                            </Row>
                        </fieldset>
                        </form>
                        {
                            this.props.clientViewPort.isXs && this.props.flowType === URLs.JOIN?undefined:
                            <div className="bottom-container">
                                {
                                    this.props.flowType !== URLs.JOIN ?
                                        <span className="not-member-join">
                                                <span
                                                    className="not-member-yet"> {!this.props.isSupportGuestMembers ? translate('Not a member yet?') : translate('New Member?')} </span>
                                                <a className="click-join"
                                                   href={"/" + URLs.JOIN + "/" + this.props.farmUrl + (!this.props.isSupportGuestMembers ? '' : '?mode=guest')}> {!this.props.isSupportGuestMembers ? translate("Summary_Account.join") : translate('Create an Account')}</a>
                                            </span> : undefined
                                }
                            </div>
                        }
                        {this.getCreateFBLogInPopup()}
                    </div>
                </div>
    };

    render() {
        if(this.props.loginStatus.isForgetPassword) {
            return (<LoginForgetPassword loginStatus={this.props.loginStatus}
                                         forgetPassword={this.props.forgetPassword} email={this.state.email}
                                         resetEmailSent={this.props.resetEmailSent}
                                         showLoading={this.props.showLoading}
                                         flowType={this.props.flowType}
                                         clientViewPort={this.props.clientViewPort}/>);
        } else if(this.props.loginStatus.isNeedToChangePassword) {
            return (<LoginChangePassword changePassword={this.props.changePassword} email={this.state.email}
                                         loginStatus={this.props.loginStatus}
                                         showLoading={this.props.showLoading}
                                         flowType={this.props.flowType}/>)
        }
        else {
            return this.getLoginPage();
        }
    }
}

const mapStateToProps = (state) => {
    return {
        clientViewPort: (state.clientViewPort || {}),
        loginStatus: (state.loginStatus || {}),
        facebookAppId: (state.staticData || {}).facebookAppId,
        isSupportGuestMembers: (state.staticData || {}).isSupportGuestMembers,
        farmUrl: (state.staticData || {}).farmUrl,
        seasonUrl: (state.staticData || {}).seasonUrl,
        memberDetails: (state.memberDetails || {}),
        showLoading: isFetching(state, FetchingTypes.LOGIN),
        fbButtonEnabled: (state.loginStatus || {}).enableFBButton
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loginWithEmail: (email, password) => {
            dispatch(loginWithEmail(email, password));
        },
        forgetPassword: email => {
            dispatch(forgetPassword(email));
        },
        logOut: memberKey => {
            dispatch(logOut(memberKey));
        },
        loginWithFacebook: (email, facebookId, remember, sourceRequestUrl) => {
            dispatch(loginWithFacebook(email, facebookId, remember, sourceRequestUrl));
        },
        setShowCreateFBAccount: (showCreateFBAccount) => {
            dispatch(setShowCreateFBAccount(showCreateFBAccount));
        },
        setForgetPassword: (forgetPassword) => {
            dispatch(setForgetPassword(forgetPassword));
        },
        changePassword: (email, password, newPassword) => {
            dispatch(changePassword(email, password, newPassword));
        },
        showChangePassword: (isNeedToChangePassword) => {
            dispatch(setChangePassword(isNeedToChangePassword))
        },
        resetStatus: () => {
            dispatch(resetStatus())
        },
        setResetPasswordEmailSent: (isResetPasswordEmailSent) => {
            dispatch(setResetPasswordEmailSent(isResetPasswordEmailSent));
        },
        createFBAccount: (email, password, facebookAppId) => {
            dispatch(activateFacebook(email, password, facebookAppId));
        },
        fetchingData: (fetchingType) => {
            dispatch(fetchingData(fetchingType));
        },
        dataFetched: () => {
            dispatch(dataFetched());
        },
        resetEmailSent: () => {
            dispatch(resetEmailSent());
        },
        showFBErrorMessage: () => {
            dispatch(showFBErrorMessage());
        },
        setEnableFbButton: (fbButtonEnabled) => {
            dispatch(setEnableFbButton(fbButtonEnabled));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( LogInScreen );


// WEBPACK FOOTER //
// ./src/containers/login/LogInScreen.js